import React from "react";

const FieldError = ({ id, children }) => {
  if (!children) return null;

  return (
    <p id={id} className="signup-form__field-error" role="alert">
      {children}
    </p>
  );
};

export default FieldError;
